import React, { useContext } from 'react';
import { Button, Popconfirm, Table, Tag, Image, Tooltip } from 'antd';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import {
  DeleteFilled,
  QuestionCircleOutlined,
  RollbackOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
dayjs.extend(calendar)

const Trim: React.FC = observer(() => {
  const {
    RecycleStore: {
      state: {
        data: { trims, total, offset, limit, search },
        ui: { recyclerLoading }
      },
      getAllDeletedItems,
      deleteItemForever,
      restoreItems
    }
  } = useContext(rootContext);

  return (
    <Table
      className="Table_block_main"
      columns={[
        {
          dataIndex: 'name',
          title: 'Name',
          align: 'center',
          render: (name: string) => {
            return <p>{name}</p>;
          }
        },
        {
          title: 'Image',
          dataIndex: 'url',
          align: 'center',
          width: 10,
          render: (value: string) => (
            <Image className="tableImage" src={value} />
          )
        },
        {
          title: 'Regions',
          dataIndex: 'region',
          align: 'center',
          render: (value, row) => {
            return !value?.length ? (
              <Tag>No Region</Tag>
            ) : (
              value?.map((item: { name: string }) => <Tag>{item.name}</Tag>)
            );
          }
        },
        {
          title: 'Deleted Time',
          align: 'center',
          dataIndex: 'deletedAt',
          render: (value: string) => dayjs(value).calendar()
        },
        {
          title: 'Action',
          width: 10,
          align: 'center',
          render: (_: any, record: any) => (
            <div className="actionButtons">
              <Tooltip title="Restore Trim">
                <Button
                  type="default"
                  className="editButton"
                  onClick={() => {
                    restoreItems({ id: record.id, type: 'TRIM' });
                  }}
                >
                  <RollbackOutlined />
                </Button>
              </Tooltip>
              <Popconfirm
                onConfirm={async () => {
                  await deleteItemForever({ id: record?.id, type: 'TRIM' });
                }}
                onCancel={e => e?.stopPropagation()}
                autoAdjustOverflow
                placement="topRight"
                title={() => (
                  <p>
                    Delete this <b>Trim</b>{' '}
                    <span style={{ color: 'red' }}>Permanently</span> ?
                  </p>
                )}
                icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
              >
                <Button ghost={true} className="deleteButton">
                  <DeleteFilled />
                </Button>
              </Popconfirm>
            </div>
          )
        }
      ]}
      loading={recyclerLoading}
      dataSource={trims}
      tableLayout="auto"
      rowKey="id"
      onChange={(pagination, _, sort) => {
        console.log(sort);
        const { current = 1, pageSize = 10 } = pagination;
        getAllDeletedItems(search, pageSize, current, 'TRIM');
      }}
      pagination={{
        disabled: recyclerLoading,
        total: total,
        pageSize: limit,
        current: offset,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '15', '20']
      }}
    />
  );
});

export default Trim;
